import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import { IDiscount } from "./discountModel";

export const findAllDiscount = createAsyncThunk(
  "Discount/FindAllDiscount",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Discount/FindAllDiscount`,
        {},
      );
      return response.data?.Data.map((item: any) => ({
        ...item,
        IsActive: item.IsActive || false,
      }));
    } catch (error: any) {
      console.error("Error Fetching Discount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllActiveDiscount = createAsyncThunk(
  "Discount/FindAllActiveDiscount",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Discount/FindAllActiveDiscount`
      );
      return response.data?.Data as IDiscount[];
    } catch (error: any) {
      console.error("Error Fetching Active Discounts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertDiscount = createAsyncThunk(
  "Discount/InsertDiscount",
  async (discountData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Discount/InsertDiscount`,
        discountData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Discount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateDiscount = createAsyncThunk(
  "Discount/UpdateDiscount",
  async (discountData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Discount/UpdateDiscount`,
        discountData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Discount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByIDDiscount = createAsyncThunk(
  "Discount/FindByIDDiscount",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Discount/FindByIDDiscount`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        FromValue: result.FromValue,
        ToValue: result.ToValue,
        DiscountPercent: result.DiscountPercent,
        IsActive: result.IsActive || false,
      } as IDiscount;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Discount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveDiscount = createAsyncThunk(
  "Discount/ActiveInActiveDiscount",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Discount/ActiveInActiveDiscount`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Discount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteDiscount = createAsyncThunk(
  "Discount/DeleteDiscount",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Discount/DeleteDiscount`,
        {
          ID,
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Discount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
